

<template>
  <div class="addcourse">
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
        <el-form-item label="章节主题" prop="chapterName" style="width: 500px;">
          <el-input v-model="ruleForm.chapterName" :disabled="isNew==2?true:false" maxlength="20" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="章节序号" prop="chapterOrder" style="width: 500px;">
          <el-input type="number" v-model.number="ruleForm.chapterOrder" :disabled="isNew==2?true:false" maxlength="5" show-word-limit min="1" @input="ruleForm.chapterOrder=Number(ruleForm.chapterOrder)<0?0:ruleForm.chapterOrder"></el-input>
        </el-form-item>

        <el-form-item :label="$t('Education.languages25')" prop="chapterHours" style="width: 500px;">
          <el-input type="number" v-model.number="ruleForm.chapterHours" :disabled="isNew==2?true:false" maxlength="5" show-word-limit min="1" @input="ruleForm.chapterHours=Number(ruleForm.chapterHours)<0?0:ruleForm.chapterHours"></el-input>
        </el-form-item> 

        <el-form-item label="主讲老师" prop="chapterTeacher" style="width: 500px;">
          <el-select v-model="ruleForm.chapterTeacher" placeholder="请选择主讲老师" style="width: 100%;">
            <el-option v-for="item in ExpertUserList" :key="item.UserID" :label="item.RealName" :value="item.UserID"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="主讲老师介绍" style="width: 500px;">
          <el-input type="textarea" v-model="ruleForm.chapterTeacherIntroduce" disabled ></el-input>
        </el-form-item>

        <el-form-item label="主讲老师照片" style="width: 500px;">
          <el-col style="width: 160px;display: inline-block;height: 160px;background: #f5f5f5;margin-right: 20px;" v-loading="teacherload">
            <el-avatar shape="square" :src="ruleForm.chapterTeacherPhoto" class="chapterTeacherPhoto"></el-avatar>
          </el-col>
      
        </el-form-item>

        <el-form-item :label="$t('Education.languages31')" style="width: 500px;">
          <el-input v-model="ruleForm.liveLinkAddress" :disabled="isNew==2?true:false" maxlength="50" show-word-limit></el-input>
        </el-form-item>

        <el-form-item :label="$t('Education.languages34')" style="width: 500px;">
          <el-col>
            <el-form-item>
              <el-date-picker
              style="width: 100%;"
              :disabled="isNew==2?true:false"
              v-model="ruleForm.liveTime"
              type="datetimerange"
              range-separator="至"
              value-format="yyyy-MM-dd HH:mm:ss"
              :start-placeholder="$t('Education.languages38')"
              :end-placeholder="$t('Education.languages39')">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item label="直播会议号" style="width: 500px;">
          <el-input v-model="ruleForm.liveConferenceCode" :disabled="isNew==2?true:false" maxlength="50" show-word-limit></el-input>
        </el-form-item>

        <!-- <el-form-item label="直播二维码">
          <el-col style="width: 160px;display: inline-block;height: 160px;background: #f5f5f5;margin-right: 20px;" v-loading="codeload">
            <img v-if="ruleForm.liveQrCode" :src="ruleForm.liveQrCode" style="width: 100%;height: 100%;">
          </el-col>
          <el-col :span="3">
            <el-upload
                class="upload-demo"
                :action="actionUrl"
                :headers="{Authorization:Authorization}"
                name="images"
                :show-file-list="false"
                accept="image/jpeg,image/png,image/jpg"
                :before-upload="codebeforeupload"
                :on-success="(value)=> handsuccess(value,'liveQrCode')"
            >
              <el-button size="small" type="primary" :disabled="isNew==2?true:false">{{ $t('Education.languages33') }}</el-button>
            </el-upload>
          </el-col>
        </el-form-item> -->

        <el-form-item label="上传培训视频">
          <el-col style="width: 160px;display: inline-block;height: 160px;background: #f5f5f5;margin-right: 20px;" v-loading="videoload">
            <div v-if="ruleForm.chapterVideo" style="height:100%;">
              <video :src="ruleForm.chapterVideo" controls="controls" style="width: 100%;height: 100%;"></video>
              <i class="el-icon-delete delete_video_icon" @click="trainhandleRemove"></i>
            </div>
          </el-col>
          <el-col :span="12" >
            <p style="width: 260px;text-align:left;">说明：请发布与网站主题相关的视频，文件大小不超过100M，视频时长不超过20分钟。文件格式请用.mp4 .avi .mov</p>

            <el-upload
                class="upload-demo"
                :action="actionUrl"
                :headers="{Authorization:Authorization}"
                name="images"
                :show-file-list="false"
                accept="video/mp4,video/avi,video/mov"
                :before-upload="videobeforeupload"
                :on-success="(value)=> handsuccess(value,'chapterVideo')"
            >
              <el-button size="small" type="primary" style="float: left;" :disabled="isNew==2?true:false">{{ $t('Education.languages33') }}</el-button>
            </el-upload>
          </el-col>
        </el-form-item>

        <el-form-item label="章节介绍" prop="chapterIntroduction" style="width: 500px;">
          <el-input type="textarea" v-model="ruleForm.chapterIntroduction" :disabled="isNew==2?true:false" maxlength="200" show-word-limit></el-input>
        </el-form-item>

        <el-form-item label="章节试卷">
            <el-select v-model="ruleForm.examId" clearable @change="changeExam" placeholder="请选择">
              <el-option
                v-for="item in optionexamListData"
                :key="item.examId"
                :label="item.examTitle"
                :value="item.examId">
              </el-option>
            </el-select>
            <!-- <el-button type="primary" style="margin-left: 20px;" @click="$router.push('addtestpaper?isNew=0&examType=3&courseId='+ruleForm.courseId)">新增试卷</el-button> -->
          </el-form-item>

          <el-form-item class="examtable">
            <el-table
                :data="examListData"
                :cell-style="{'text-align':'center'}"
                :header-cell-style="{'text-align':'center'}"
                style="width: 100%">
              <el-table-column prop="examTitle" label="试卷名称"></el-table-column>
              <el-table-column prop="examRadioNum" label="单选题"></el-table-column>
              <el-table-column prop="examMultipleNum" label="多选题"></el-table-column>
              <el-table-column prop="examQuestionNum" label="问答题"></el-table-column>
              <el-table-column prop="updateBy" label="最近操作者"></el-table-column>
              <el-table-column prop="updateTime" label="更新时间"></el-table-column>
              <el-table-column label="操作">
                <template v-slot="scope">
                  <span v-if="scope.row" class="operateitem" @click="$router.push('addtestpaper?isNew=1&examId='+scope.row.examId)">维护试卷</span>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')" :disabled="isNew==2?true:false">{{isNew==0?'立即创建':'修改'}}</el-button>
          <el-button @click="$router.go(-1)">返回</el-button>
        </el-form-item>
      </el-form>

      
    </div>
  </div>
</template>
<script>
export default{
  name:'addcourse',
  data(){
    return{
      actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
      Authorization:sessionStorage.getItem('Authorization'),
      rules: {
        coursename: [{ required: true, message:"请输入课程名", trigger: 'blur'}],
        chapterName:[{required: true, message:"请输入章节主题", trigger: 'blur'}],
        chapterOrder:[{required: true, message:"请输入章节序号", trigger: 'blur'}],
        chapterHours:[{required: true, message:"请输入课时数", trigger: 'blur'}],
        chapterTeacher:[{required: true, message:"请选择主讲老师", trigger: 'change'}],
        chapterTeacherPhoto: [{ required: true, message:"请上传图片", trigger: 'change' }],
        chapterIntroduction: [ { required: true, message: "请填写", trigger: 'blur' }]
      },
      ruleForm: {
        courseId:'',
        chapterId:'',
        coursename:'',
        chapterName: '',
        chapterOrder:'',
        chapterHours: '',
        chapterTeacher:'',
        chapterTeacherName:[],
        chapterTeacherIntroduce: '',
        chapterTeacherPhoto:'',
        liveLinkAddress:'',
        liveTime:[],
        liveStartTime:'',
        liveEndTime:'',
        liveConferenceCode:'',
        liveQrCode:'',
        chapterVideo:'',
        chapterIntroduction:'',
        examId:'',
        chapterVideoHours:0
      },
      videoload:false,
      teacherload:false,
      codeload:false,
      optionexamListData:[],
      examListData:[],
      examParams:{
        pageNum:1,
        pageSize:20,
        examType:3
      },
      dropUserAll: [],
      isNew:'',
      ExpertUserList:[]
    }
  },
  watch:{
    'ruleForm.liveTime'(newval,oldval){
      if(newval==null){
        this.ruleForm.liveStartTime='';
        this.ruleForm.liveEndTime='';
      }else{
        this.ruleForm.liveStartTime=newval[0];
        this.ruleForm.liveEndTime=newval[1];
      }
    },
    'ruleForm.chapterTeacher'(newval,oldval){
      if(newval){
        this.ruleForm.chapterTeacherIntroduce=this.ExpertUserList.find(item=>item.UserID==newval).IndividualResume;
        this.ruleForm.chapterTeacherPhoto=this.ExpertUserList.find(item=>item.UserID==newval).ZHeadPhotoURL;
      }
    }
  },
  activated() {
    this.ruleForm=this.$options.data().ruleForm;
    this.isNew=parseInt(this.$route.query.isNew);
    this.ruleForm.courseId=this.$route.query.courseId;
    this.ruleForm.chapterId=this.$route.query.chapterId;
    // this.dropGetUserAll();旧
    this.getExpertUser()
    this.getexamlist();
  },
  methods:{
    // 查看详情
    chapterDetail(){
      this.$Http_Get('edu/chapter/getInfo/'+this.ruleForm.chapterId).then(res=>{
        if(res.Code==0){
          this.examListData=[];
          // this.ruleForm=res.Data;
          this.ruleForm.coursename=res.Data.coursename,
          this.ruleForm.chapterName=res.Data.chapterName,
          this.ruleForm.chapterOrder=res.Data.chapterOrder,
          this.ruleForm.chapterHours=res.Data.chapterHours,
          this.ruleForm.chapterTeacher=res.Data.chapterTeacher,
          this.ruleForm.liveLinkAddress=res.Data.liveLinkAddress,
          this.ruleForm.liveTime=[res.Data.liveStartTime,res.Data.liveEndTime],
          this.ruleForm.liveStartTime=res.Data.liveStartTime,
          this.ruleForm.liveEndTime=res.Data.liveEndTime,
          this.ruleForm.liveConferenceCode=res.Data.liveConferenceCode,
          this.ruleForm.liveQrCode=res.Data.liveQrCode,
          this.ruleForm.chapterVideo=res.Data.chapterVideo,
          this.ruleForm.chapterIntroduction=res.Data.chapterIntroduction,
          this.ruleForm.examId=res.Data.examId,
          this.ruleForm.chapterVideoHours=res.Data.chapterVideoHours
          this.responseLecturer(res.Data.chapterTeacher);
          if(res.Data.exam.length!=0){
            this.examListData.push(res.Data.exam);
          }
        }else{
          this.$message({type: 'error', message: res.Message});
        }
      })
    },

    // 获取章节试卷
    getexamlist(){
      this.$Http_Post('edu/exam/list',this.examParams).then(res=>{
        if(res.Code==0){
          this.optionexamListData=res.Data;
        }else{
          this.$message({type: 'error', message:"获取试卷列表失败"});
        }
      })
    },

    changeExam(val){
      this.examListData=[];
      for(let item of this.optionexamListData){
        if(item.examId==val){
          this.examListData.push(item);
        }
      }
    },

    // 回显主讲老师
    responseLecturer(val){
      for(let item of this.dropUserAll){
        if(item.children.length>0){
          for(let items of item.children){
            if(items.value==val){
              this.ruleForm.chapterTeacherName=[item.value,val];
            }
          }
        }
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let Url=this.isNew==0?'edu/chapter/add':'edu/chapter/edit';
          this.$Http_Post(Url,this.ruleForm).then(res=>{
            if(res.Code==0){
              this.ruleForm=this.$options.data().ruleForm;
              this.examListData=[];
              this.$message({type: 'success', message: res.Message})
              this.$router.go(-1);
            }else{
              this.$message({type: 'error', message: res.Message})
            }
          })
        } else {
          this.$message({type: 'error', message: "请填写完整信息"})
          return false;
        }
      });
    },
    // 上传老师头像
    teacherbeforeupload(file){
      if(file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
        this.teacherload=true;
      }else{
        this.$message({type: 'error', message:"请上传正确的图片格式"});
      }
    },

    // 上传直播二维码
    codebeforeupload(file){
      if(file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
        this.codeload=true;
      }else{
        this.$message({type: 'error', message:"请上传正确的图片格式"});
      }
    },

    // 上传视频
    videobeforeupload(file){
      var _this=this;
      if(file.type == 'video/mp4' || file.type == 'video/avi' || file.type == 'video/mov') {
        this.videoload=true;
          var url = URL.createObjectURL(file);         
          var audioElement = new Audio(url);
          audioElement.addEventListener("loadedmetadata",
            function() {        
              _this.ruleForm.chapterVideoHours=parseInt(audioElement.duration);   
            });
            
      }else{
        this.$message({type: 'error', message:"请上传正确的视频格式"});
      }
    },

    // 上传成功
    handsuccess(file,name){
      this.ruleForm[name]=file.Data;
      this.videoload=false;
      this.codeload=false;
      this.teacherload=false;
    },

    // 删除视频
    trainhandleRemove(file,name){
      this.ruleForm.chapterVideo='';
      this.$message({type: 'success', message: "删除成功"});
    },

    // 
    dropGetUserAll() {
      this.$Http_Post('ConsultSubscribe/GetUserAll', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dropUserAll = res.Data;
          if(this.ruleForm.chapterId && (this.isNew==1 || this.isNew==2)){
            this.chapterDetail();
          }else{
            this.examListData=[];
          }
        }
      });
    },

    //获取专家列表
    getExpertUser(){
      this.$Http_Post('User/getExpertUser', {RealName: "",pageIndex: 1,pageSize: "100"}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.ExpertUserList = res.Data;
          if(this.ruleForm.chapterId && (this.isNew==1 || this.isNew==2)){
            this.chapterDetail();
          }else{
            this.examListData=[];
          }
        }
      });
    },

  }
}
</script>

<style>
.addcourse{background: #fff;}
.addcourse .content{padding:30px;}
.addcourse .chapterTeacherPhoto{width: 100%;height: 100%;}
.addcourse .chapterTeacherPhoto img{width: 100%!important;} 
.addcourse .delete_video_icon{position: absolute;top: 0;left: 130px;z-index: 9;cursor: pointer;font-size: 20px;}
</style>